/*
 * VINKOVA — Sistema de pop-ups propio en el tema.
 *
 * - Cada bloque de la sección `vk-email-popup` es un pop-up independiente.
 * - Se muestra el primer bloque activo cuyas reglas encajan con la visita
 *   (el Liquid ya descarta los bloques de otro idioma).
 * - Admite dos modos: captación de email (formulario nativo de Shopify con
 *   etiquetas) o aviso directo con botón (sin pedir email).
 * - Disparadores: página nº N de la visita, % de bajada (scroll), segundos en
 *   página y/o intención de salida en ordenador.
 * - Frenos: nunca encima del aviso de cookies (espera a que conteste), nunca
 *   si ya hay algo en la cesta, nunca a quien ya está suscrita.
 * - En móvil se abre como tarjeta desde abajo, sin bloquear la página.
 * - En el Personalizador de Shopify (`designMode`), muestra una barra superior
 *   para alternar entre el Paso 1, el Paso 2 y la Pestaña lateral sin que se
 *   cierre la vista previa al escribir.
 *
 * Para probar en vivo cualquier pop-up sin esperar ni guardar estado: añadir
 * ?vkp_test=<identificador> a la dirección (por ejemplo ?vkp_test=b5-es).
 */
(function () {
  'use strict';

  if (window.VkPopup) return;

  var PREFIX = 'vkp:';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PAGEVIEW_DELAY_MS = 12000;
  var MIN_SESSION_MS = 20000;
  var MIN_SCROLL_WAIT_MS = 15000;
  var MIN_EXIT_WAIT_MS = 8000;
  var MODAL_POLL_MS = 1500;
  var MODAL_MAX_WAIT_MS = 120000;
  var MODAL_AFTER_MS = 2500;
  var CONSENT_POLL_MS = 1000;
  var CONSENT_MAX_WAIT_MS = 90000;
  var CONSENT_AFTER_MS = 1500;

  /* ---------------------------------------------------------------------- */
  /* Almacenamiento seguro                                                  */
  /* ---------------------------------------------------------------------- */

  function storage(type) {
    return {
      get: function (key) {
        try { return window[type].getItem(PREFIX + key); } catch (e) { return null; }
      },
      set: function (key, value) {
        try { window[type].setItem(PREFIX + key, value); } catch (e) { /* sin almacenamiento */ }
      },
      remove: function (key) {
        try { window[type].removeItem(PREFIX + key); } catch (e) { /* sin almacenamiento */ }
      }
    };
  }

  var local = storage('localStorage');
  var session = storage('sessionStorage');

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  /* ---------------------------------------------------------------------- */
  /* Contexto de la visita                                                  */
  /* ---------------------------------------------------------------------- */

  function currentPath() {
    var path = window.location.pathname;
    try { path = decodeURIComponent(path); } catch (e) { /* ruta sin codificar */ }
    return path.toLowerCase();
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isHomepage() {
    var path = currentPath().replace(/\/+$/, '');
    var root = shopRoot().toLowerCase().replace(/\/+$/, '');
    return path === '' || path === root;
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function otherModalOpen() {
    var nl = document.getElementById('NewsletterModal');
    if (nl && !nl.hasAttribute('hidden') && nl.getAttribute('aria-modal') === 'true') return true;
    if (document.querySelector('dialog[open], .vk-panel[open], .vk-mm[open], .vk-me[open], .vk-fs[open]')) return true;
    // 03-nov-2026: tampoco encima del buscador abierto (tapaba los resultados y el teclado).
    if (document.querySelector('#SearchDrawer[open], body.predictive-search-open')) return true;
    if (document.querySelector('.vk-cesta.is-open, cart-drawer.is-open, #CartDrawer.is-open, #vk-sg-modal.is-open, #vk-sg-modal[aria-hidden="false"]')) return true;
    var chatWin = document.getElementById('vinkova-chat-window');
    if (chatWin && chatWin.classList.contains('vinkova-open')) return true;
    return false;
  }

  var pageLoadedAt = Date.now();
  var sessionStartAt = (function () {
    var ts = parseInt(session.get('session_start'), 10);
    if (!ts || ts > pageLoadedAt) {
      ts = pageLoadedAt;
      session.set('session_start', String(ts));
    }
    return ts;
  })();

  // Páginas vistas en esta visita (una por carga de página).
  var pageviews = (function () {
    var n = (parseInt(session.get('pageviews'), 10) || 0) + 1;
    session.set('pageviews', String(n));
    return n;
  })();

  // Aviso de cookies de Shopify todavía en pantalla (sin contestar).
  function consentPending() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    var style = window.getComputedStyle(banner);
    return style.display !== 'none' && style.visibility !== 'hidden' && banner.offsetHeight > 0;
  }

  var cartPromise = null;

  function cartHasItems(fresh) {
    if (fresh) cartPromise = null;
    if (cartPromise) return cartPromise;
    cartPromise = fetch(shopRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) { return !!(cart && cart.item_count > 0); })
      .catch(function () { return false; });
    return cartPromise;
  }

  // Si añade algo a la cesta en esta página, olvidamos la consulta anterior.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) cartPromise = Promise.resolve(true);
  }, true);

  var countryPromise = null;

  function detectCountry() {
    if (countryPromise) return countryPromise;
    var fallback = (window.Shopify && window.Shopify.country) || '';
    var cached = session.get('country');
    if (cached) {
      countryPromise = Promise.resolve(cached);
      return countryPromise;
    }
    countryPromise = fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var code = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        code = (code || fallback || '').toUpperCase();
        if (code) session.set('country', code);
        return code;
      })
      .catch(function () { return fallback.toUpperCase(); });
    return countryPromise;
  }

  /* ---------------------------------------------------------------------- */
  /* Reglas de visualización                                                */
  /* ---------------------------------------------------------------------- */

  function matchesList(path, list) {
    for (var i = 0; i < list.length; i++) {
      if (path.indexOf(list[i]) !== -1) return true;
    }
    return false;
  }

  var RULES = {
    page: function (cfg) {
      var home = isHomepage();
      if (cfg.onlyHome && !home) return false;
      if (cfg.excludeHome && home) return false;
      var path = currentPath();
      if (cfg.urlNotContains.length && matchesList(path, cfg.urlNotContains)) return false;
      if (!cfg.urlContains.length) return true;
      return matchesList(path, cfg.urlContains);
    },
    device: function (cfg) {
      if (cfg.devices === 'desktop') return !isMobile();
      if (cfg.devices === 'mobile') return isMobile();
      return true;
    },
    country: function (cfg) {
      if (!cfg.countries.length) return true;
      return detectCountry().then(function (code) {
        return cfg.countries.indexOf(code) !== -1;
      });
    }
  };

  function matches(cfg) {
    var results = Object.keys(RULES).map(function (name) { return RULES[name](cfg); });
    return Promise.all(results).then(function (values) {
      return values.every(Boolean);
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Analítica                                                              */
  /* ---------------------------------------------------------------------- */

  function track(name, cfg, extra) {
    var data = {
      popup: cfg.key,
      page_path: window.location.pathname,
      locale: (window.Shopify && window.Shopify.locale) || ''
    };
    if (extra) {
      Object.keys(extra).forEach(function (k) { data[k] = extra[k]; });
    }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* la analítica nunca debe interrumpir el pop-up */ }
    document.dispatchEvent(new CustomEvent('vkp:' + name, { detail: data }));
  }

  /* ---------------------------------------------------------------------- */
  /* Configuración y Variante                                               */
  /* ---------------------------------------------------------------------- */

  function splitClean(str, lower) {
    return (str || '')
      .split(',')
      .map(function (s) { return lower ? s.trim().toLowerCase() : s.trim(); })
      .filter(Boolean);
  }

  function readConfig(el) {
    var d = el.dataset;
    return {
      blockId: d.blockId,
      key: d.key || d.blockId,
      title: d.title || d.key || 'Pop-up',
      popupType: d.popupType || 'email',
      editorPreview: d.editorPreview || 'start',
      active: d.active === 'true',
      urlContains: splitClean(d.urlContains, true),
      urlNotContains: splitClean(d.urlNotContains, true),
      excludeHome: d.excludeHome === 'true',
      onlyHome: d.onlyHome === 'true',
      countries: splitClean(d.countries, false),
      devices: d.devices || 'all',
      pages: parseInt(d.pages, 10) || 0,
      scroll: parseInt(d.scroll, 10) || 0,
      delaySeconds: parseInt(d.delaySeconds, 10) || 0,
      exitIntent: d.exitIntent === 'true',
      cooldownDays: parseInt(d.cooldownDays, 10) || 0,
      skipIfCart: d.skipIfCart === 'true',
      legacyId: (d.legacyId || '').trim(),
      tags: d.tags || '',
      errorInvalid: d.errorInvalid || 'Please enter valid email address!',
      errorGeneric: d.errorGeneric || 'Sorry, please try again later!'
    };
  }

  function summarizeRules(cfg) {
    var parts = [];
    if (cfg.onlyHome) {
      parts.push('Solo portada');
    } else if (cfg.urlContains.length) {
      parts.push('URL con «' + cfg.urlContains.join(', ') + '»' + (cfg.excludeHome ? ' (sin portada)' : ''));
    } else {
      parts.push(cfg.excludeHome ? 'Toda la web salvo portada' : 'Toda la web');
    }
    if (cfg.countries.length) parts.push('Países: ' + cfg.countries.join(', '));
    if (cfg.devices === 'desktop') parts.push('Solo ordenador');
    if (cfg.devices === 'mobile') parts.push('Solo móvil');
    var triggers = [];
    if (cfg.pages > 1) triggers.push('página nº ' + cfg.pages + ' de la visita');
    if (cfg.scroll > 0) triggers.push('bajar ' + cfg.scroll + '%');
    if (cfg.delaySeconds > 0) triggers.push(cfg.delaySeconds + ' s');
    if (cfg.exitIntent) triggers.push('al ir a salir');
    if (!triggers.length) triggers.push('inmediato');
    parts.push('Salta: ' + triggers.join(' o '));
    if (cfg.skipIfCart) parts.push('no si ya hay cesta');
    if (cfg.cooldownDays > 0) parts.push('cerrado = ' + cfg.cooldownDays + ' días sin salir');
    return parts.join(' · ');
  }

  function Variant(el, root, options) {
    this.el = el;
    this.root = root;
    this.cfg = readConfig(el);
    this.testMode = !!options.testMode;
    this.designMode = !!options.designMode;
    this.modal = el.querySelector('.vkp__modal');
    this.form = el.querySelector('form');
    this.input = el.querySelector('.vkp__input');
    this.error = el.querySelector('[data-vkp-error]');
    this.submit = el.querySelector('[data-vkp-submit]');
    this.teaser = el.querySelector('[data-vkp-teaser]');
    this.isOpen = false;
    this.pending = false;
    this.lastFocus = null;
    this.delayTimer = null;
    this.pageviewTimer = null;
    this.scrollWaitTimer = null;
    this.onKeydown = this.onKeydown.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onExitIntent = this.onExitIntent.bind(this);
    this.bind();
  }

  Variant.prototype.persist = function () {
    return !this.testMode && !this.designMode;
  };

  Variant.prototype.isSubscribed = function () {
    if (!this.persist()) return false;
    if (this.root.dataset.customerSubscribed === 'true') return true;
    if (local.get('subscribed:all')) return true;
    if (local.get('subscribed:' + this.cfg.key)) return true;
    if (this.root.dataset.respectLegacy === 'true') {
      if (this.cfg.legacyId && getCookie('ecomsend_pp_success_subscribed' + this.cfg.legacyId) === 'true') return true;
      if (getCookie('ecomsend_pp_existing_subscriber') === 'true') return true;
    }
    return false;
  };

  Variant.prototype.closedRecently = function () {
    if (!this.persist()) return false;
    if (session.get('closed:' + this.cfg.key) === '1') return true;
    if (this.cfg.cooldownDays > 0) {
      var ts = parseInt(local.get('closed_at:' + this.cfg.key), 10);
      if (ts && (Date.now() - ts) < this.cfg.cooldownDays * 86400000) return true;
    }
    return false;
  };

  Variant.prototype.teaserClosed = function () {
    return this.persist() && session.get('teaser-closed:' + this.cfg.key) === '1';
  };

  Variant.prototype.bind = function () {
    var self = this;
    this.el.addEventListener('click', function (event) {
      if (event.target.closest('[data-vkp-close]')) {
        event.preventDefault();
        self.close();
      } else if (event.target.closest('[data-vkp-open]')) {
        event.preventDefault();
        self.open('teaser');
      } else if (event.target.closest('[data-vkp-teaser-close]')) {
        event.preventDefault();
        if (self.persist()) session.set('teaser-closed:' + self.cfg.key, '1');
        self.setTeaser(false);
      } else if (event.target.closest('[data-vkp-copy]')) {
        event.preventDefault();
        self.copyCode(event.target.closest('[data-vkp-copy]'));
      } else if (event.target.closest('[data-vkp-cta]')) {
        if (self.persist()) {
          session.set('closed:' + self.cfg.key, '1');
          if (self.cfg.cooldownDays > 0) local.set('closed_at:' + self.cfg.key, String(Date.now()));
        }
        track('vk_popup_cta_click', self.cfg);
      }
    });
    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        self.subscribe();
      });
    }
  };

  Variant.prototype.clearTriggers = function () {
    window.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('mouseout', this.onExitIntent);
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
    if (this.pageviewTimer) {
      clearTimeout(this.pageviewTimer);
      this.pageviewTimer = null;
    }
    if (this.scrollWaitTimer) {
      clearTimeout(this.scrollWaitTimer);
      this.scrollWaitTimer = null;
    }
  };

  Variant.prototype.start = function () {
    var self = this;
    var img = this.el.querySelector('img');
    if (img) img.loading = 'eager';
    this.el.hidden = false;

    if (this.resumeAfterChallenge()) return;

    if (this.testMode) {
      setTimeout(function () { self.open('test'); }, 250);
      return;
    }

    if (this.isSubscribed()) {
      this.el.hidden = true;
      return;
    }

    this.setTeaser(true);
    if (this.closedRecently()) return;

    var hasPages = this.cfg.pages > 0;
    var hasScroll = this.cfg.scroll > 0;
    var hasDelay = this.cfg.delaySeconds > 0;
    var hasExit = this.cfg.exitIntent && !isMobile();

    if (!hasPages && !hasScroll && !hasDelay && !hasExit) {
      this.tryOpen('auto');
      return;
    }

    if (hasPages && pageviews >= this.cfg.pages) {
      var elapsedSession = Date.now() - sessionStartAt;
      var waitPage = Math.max(PAGEVIEW_DELAY_MS, MIN_SESSION_MS - elapsedSession);
      this.pageviewTimer = setTimeout(function () { self.tryOpen('pageview'); }, waitPage);
    }

    if (hasScroll) {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    if (hasDelay) {
      this.delayTimer = setTimeout(function () { self.tryOpen('delay'); }, this.cfg.delaySeconds * 1000);
    }

    if (hasExit) {
      document.addEventListener('mouseout', this.onExitIntent);
    }
  };

  // Todas las aperturas automáticas pasan por aquí: comprueba los frenos.
  Variant.prototype.tryOpen = function (source) {
    var self = this;
    if (this.isOpen || this.pending || this.closedRecently()) return;
    this.pending = true;
    this.clearTriggers();

    var check = this.cfg.skipIfCart ? cartHasItems() : Promise.resolve(false);
    check.then(function (busy) {
      if (busy) {
        self.pending = false;
        return;
      }
      self.whenConsentAnswered(function () {
        self.whenModalClosed(function () {
          var recheck = self.cfg.skipIfCart ? cartHasItems(true) : Promise.resolve(false);
          recheck.then(function (stillBusy) {
            self.pending = false;
            if (stillBusy || self.isOpen || self.closedRecently() || otherModalOpen()) return;
            self.open(source);
          });
        });
      });
    });
  };

  Variant.prototype.whenConsentAnswered = function (callback) {
    if (this.root.dataset.waitConsent !== 'true' || !consentPending()) {
      callback();
      return;
    }
    var waited = 0;
    var timer = setInterval(function () {
      waited += CONSENT_POLL_MS;
      if (!consentPending()) {
        clearInterval(timer);
        setTimeout(callback, CONSENT_AFTER_MS);
      } else if (waited >= CONSENT_MAX_WAIT_MS) {
        clearInterval(timer);
      }
    }, CONSENT_POLL_MS);
  };

  Variant.prototype.whenModalClosed = function (callback) {
    if (!otherModalOpen()) {
      callback();
      return;
    }
    var waited = 0;
    var timer = setInterval(function () {
      waited += MODAL_POLL_MS;
      if (!otherModalOpen()) {
        clearInterval(timer);
        setTimeout(callback, MODAL_AFTER_MS);
      } else if (waited >= MODAL_MAX_WAIT_MS) {
        clearInterval(timer);
      }
    }, MODAL_POLL_MS);
  };

  Variant.prototype.scrolledPercent = function () {
    var doc = document.documentElement;
    var max = (document.body.scrollHeight || doc.scrollHeight) - (window.innerHeight || doc.clientHeight);
    if (max <= 0) return 0;
    return ((document.body.scrollTop || doc.scrollTop) / max) * 100;
  };

  Variant.prototype.onScroll = function () {
    if (this.scrollTicking) return;
    this.scrollTicking = true;
    var self = this;
    setTimeout(function () {
      self.scrollTicking = false;
      if (self.isOpen || self.pending || self.closedRecently()) return;
      if (self.scrolledPercent() >= self.cfg.scroll) {
        var elapsedPage = Date.now() - pageLoadedAt;
        if (elapsedPage < MIN_SCROLL_WAIT_MS) {
          if (!self.scrollWaitTimer) {
            self.scrollWaitTimer = setTimeout(function () {
              self.scrollWaitTimer = null;
              if (self.scrolledPercent() >= self.cfg.scroll) self.tryOpen('scroll');
            }, MIN_SCROLL_WAIT_MS - elapsedPage);
          }
          return;
        }
        self.tryOpen('scroll');
      }
    }, 200);
  };

  Variant.prototype.onExitIntent = function (event) {
    if (Date.now() - pageLoadedAt < MIN_EXIT_WAIT_MS) return;
    if (event.clientY > 15) return;
    if (event.relatedTarget || event.toElement) return;
    this.tryOpen('exit_intent');
  };

  Variant.prototype.setTeaser = function (visible) {
    if (!this.teaser) return;
    var show = visible && (this.designMode || (!this.teaserClosed() && !this.isSubscribed()));
    this.teaser.hidden = !show;
  };

  Variant.prototype.showStep = function (name) {
    this.el.querySelectorAll('[data-vkp-step]').forEach(function (step) {
      step.hidden = step.getAttribute('data-vkp-step') !== name;
    });
  };

  Variant.prototype.open = function (source) {
    if (this.isOpen) return;
    this.clearTriggers();
    if (window.VkPopup.openVariant && window.VkPopup.openVariant !== this) {
      window.VkPopup.openVariant.close(true);
    }
    window.VkPopup.openVariant = this;
    this.isOpen = true;
    this.lastFocus = document.activeElement;
    this.el.hidden = false;
    this.el.classList.add('is-open');
    this.setTeaser(false);
    document.documentElement.classList.add('vkp-open');
    // En móvil es una tarjeta desde abajo: la página sigue usable.
    if (!isMobile()) document.documentElement.classList.add('vkp-lock');
    document.addEventListener('keydown', this.onKeydown);
    if (this.modal && !this.designMode) this.modal.focus({ preventScroll: true });
    if (!this.designMode) track('vk_popup_view', this.cfg, { trigger: source || 'auto' });
  };

  Variant.prototype.close = function (silent) {
    if (!this.isOpen) return;
    var subscribed = this.el.classList.contains('is-subscribed');
    this.isOpen = false;
    this.el.classList.remove('is-open');
    document.documentElement.classList.remove('vkp-lock', 'vkp-open');
    document.removeEventListener('keydown', this.onKeydown);
    if (window.VkPopup.openVariant === this) window.VkPopup.openVariant = null;
    if (this.persist() && !subscribed) {
      session.set('closed:' + this.cfg.key, '1');
      if (this.cfg.cooldownDays > 0) local.set('closed_at:' + this.cfg.key, String(Date.now()));
    }
    if (subscribed) {
      if (this.teaser) this.teaser.hidden = true;
    } else {
      this.setTeaser(true);
    }
    if (!this.designMode && this.lastFocus && typeof this.lastFocus.focus === 'function') {
      try { this.lastFocus.focus({ preventScroll: true }); } catch (e) { /* sin foco previo */ }
    }
    if (!silent && !subscribed && !this.designMode) track('vk_popup_close', this.cfg);
  };

  Variant.prototype.onKeydown = function (event) {
    if (event.key === 'Escape') {
      this.close();
      return;
    }
    if (event.key !== 'Tab' || !this.modal) return;
    var focusable = Array.prototype.filter.call(
      this.modal.querySelectorAll('a[href], button, input:not([type="hidden"])'),
      function (node) { return !node.disabled && node.offsetParent !== null; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  Variant.prototype.copyCode = function (button) {
    var code = button.getAttribute('data-code') || '';
    var label = button.querySelector('[data-vkp-copy-label]');
    var done = function () {
      if (!label) return;
      var original = label.getAttribute('data-original') || label.textContent;
      label.setAttribute('data-original', original);
      label.textContent = button.getAttribute('data-copied') || original;
      button.classList.add('is-copied');
      setTimeout(function () {
        label.textContent = original;
        button.classList.remove('is-copied');
      }, 2200);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var temp = document.createElement('textarea');
      temp.value = code;
      temp.setAttribute('readonly', '');
      temp.style.position = 'fixed';
      temp.style.opacity = '0';
      document.body.appendChild(temp);
      temp.select();
      try { document.execCommand('copy'); } catch (e) { /* sin portapapeles */ }
      document.body.removeChild(temp);
      done();
    }
    if (!this.designMode) track('vk_popup_copy_code', this.cfg);
  };

  Variant.prototype.setError = function (message) {
    if (!this.error) return;
    this.error.textContent = message || '';
    this.error.hidden = !message;
    if (this.input) this.input.setAttribute('aria-invalid', message ? 'true' : 'false');
  };

  Variant.prototype.setLoading = function (loading) {
    if (!this.submit) return;
    this.submit.disabled = loading;
    this.submit.classList.toggle('is-loading', loading);
  };

  Variant.prototype.subscribe = function () {
    var self = this;
    var email = (this.input && this.input.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      this.setError(this.cfg.errorInvalid);
      if (this.input) this.input.focus();
      return;
    }
    this.setError('');

    if (this.designMode) {
      this.succeed(email, { skipSideEffects: true });
      return;
    }

    this.setLoading(true);
    var body = new FormData(this.form);

    fetch(this.form.action, {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        // Verificación de seguridad de Shopify: enviar el formulario directamente.
        if (res.url && res.url.indexOf('/challenge') !== -1) {
          session.set('pending', self.cfg.key);
          session.set('pending-email', email);
          self.form.submit();
          return null;
        }
        if (res.url && res.url.indexOf('customer_posted=true') !== -1) return { ok: true };
        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var form = self.form.id ? doc.getElementById(self.form.id) : null;
          var serverError = form && form.querySelector('[data-vkp-server-error]');
          if (serverError) return { ok: false, message: serverError.textContent.trim() };
          return { ok: res.ok };
        });
      })
      .then(function (result) {
        if (!result) return;
        self.setLoading(false);
        if (result.ok) {
          self.succeed(email);
        } else {
          var invalid = /email/i.test(result.message || '');
          self.setError(invalid ? self.cfg.errorInvalid : self.cfg.errorGeneric);
        }
      })
      .catch(function () {
        self.setLoading(false);
        self.setError(self.cfg.errorGeneric);
      });
  };

  Variant.prototype.succeed = function (email, options) {
    options = options || {};
    this.el.classList.add('is-subscribed');
    this.showStep('success');
    if (this.teaser) this.teaser.hidden = true;
    if (options.skipSideEffects) return;

    if (this.persist()) {
      local.set('subscribed:' + this.cfg.key, String(Date.now()));
      local.set('subscribed:all', String(Date.now()));
    }
    track('vk_popup_subscribe', this.cfg);
    this.metaLead();
    this.notifyWebhook(email);
  };

  Variant.prototype.metaLead = function () {
    if (this.root.dataset.metaLead !== 'true' || typeof window.fbq !== 'function') return;
    try {
      window.fbq('track', 'Lead', {
        content_name: this.root.dataset.metaName || 'Popup Vinkova',
        content_category: 'Email Signup'
      });
    } catch (e) { /* sin píxel de Meta */ }
  };

  Variant.prototype.notifyWebhook = function (email) {
    var url = this.root.dataset.webhook;
    if (!url || !email) return;
    var cfg = this.cfg;
    var send = function (country) {
      var params = new URLSearchParams({
        email: email,
        popup: cfg.key,
        tags: cfg.tags,
        page: window.location.href,
        locale: (window.Shopify && window.Shopify.locale) || '',
        country: country || ''
      });
      try {
        fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, body: params });
      } catch (e) { /* el aviso es secundario */ }
    };
    detectCountry().then(send, function () { send(''); });
  };

  Variant.prototype.resumeAfterChallenge = function () {
    if (this.testMode || this.designMode) return false;
    if (session.get('pending') !== this.cfg.key) return false;
    if (window.location.search.indexOf('customer_posted=true') === -1) return false;
    var email = session.get('pending-email') || '';
    session.remove('pending');
    session.remove('pending-email');
    this.open('resume');
    this.succeed(email);
    return true;
  };

  /* ---------------------------------------------------------------------- */
  /* Modo Editor (Personalizador de Shopify)                                */
  /* ---------------------------------------------------------------------- */

  var editorState = {
    blockId: null,
    stepOverride: null
  };

  function showInEditor(variant, stepOverride) {
    if (!variant) return;
    var root = variant.root;
    var bar = root.querySelector('[data-vkp-editor-bar]');
    var step = stepOverride || variant.cfg.editorPreview || 'start';

    (root.vkpVariants || []).forEach(function (v) {
      if (v !== variant) {
        v.close(true);
        v.el.hidden = true;
      }
    });

    var img = variant.el.querySelector('img');
    if (img) img.loading = 'eager';

    if (step === 'hide') {
      variant.close(true);
      variant.setTeaser(false);
      variant.el.hidden = true;
    } else if (step === 'teaser') {
      variant.close(true);
      variant.el.hidden = false;
      variant.el.classList.remove('is-subscribed');
      variant.setTeaser(true);
    } else if (step === 'success') {
      variant.el.classList.remove('is-subscribed');
      variant.showStep('success');
      variant.open('editor');
    } else {
      variant.el.classList.remove('is-subscribed');
      variant.showStep('start');
      variant.open('editor');
    }

    if (bar) {
      bar.hidden = false;
      var statusEl = bar.querySelector('[data-vkp-editor-status]');
      var titleEl = bar.querySelector('[data-vkp-editor-title]');
      var summaryEl = bar.querySelector('[data-vkp-editor-summary]');
      if (statusEl) {
        statusEl.textContent = variant.cfg.active ? 'ACTIVO' : 'APAGADO';
        statusEl.classList.toggle('is-off', !variant.cfg.active);
      }
      if (titleEl) titleEl.textContent = variant.cfg.title + ' (' + variant.cfg.key + ')';
      if (summaryEl) summaryEl.textContent = summarizeRules(variant.cfg);

      var successBtn = bar.querySelector('[data-vkp-editor-step="success"]');
      if (successBtn) successBtn.hidden = variant.cfg.popupType === 'announcement';

      bar.querySelectorAll('[data-vkp-editor-step]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-vkp-editor-step') === step);
      });
    }
  }

  function bindEditorBar(root) {
    var bar = root.querySelector('[data-vkp-editor-bar]');
    if (!bar || bar.vkpBound) return;
    bar.vkpBound = true;
    bar.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-vkp-editor-step]');
      if (!btn || !editorState.blockId) return;
      event.preventDefault();
      var step = btn.getAttribute('data-vkp-editor-step');
      editorState.stepOverride = step;
      var variant = findVariantByBlock(editorState.blockId);
      if (variant) showInEditor(variant, step);
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Arranque                                                               */
  /* ---------------------------------------------------------------------- */

  function testKey() {
    try {
      return new URLSearchParams(window.location.search).get('vkp_test');
    } catch (e) {
      return null;
    }
  }

  // Quien se apunta en el formulario del pie vuelve con customer_posted=true:
  // a partir de ahí no le volvemos a ofrecer el pop-up.
  function rememberFooterSignup() {
    if (window.location.search.indexOf('customer_posted=true') === -1) return;
    if (session.get('pending')) return;
    local.set('subscribed:all', String(Date.now()));
  }

  function initRoot(root) {
    if (!root || root.vkpInitialized) return;
    root.vkpInitialized = true;

    var designMode = root.dataset.designMode === 'true';
    var forcedKey = testKey();
    var variants = Array.prototype.map.call(root.querySelectorAll('[data-vkp-variant]'), function (el) {
      return new Variant(el, root, {
        designMode: designMode,
        testMode: !!forcedKey && el.dataset.key === forcedKey
      });
    });
    root.vkpVariants = variants;

    if (designMode) {
      bindEditorBar(root);
      if (editorState.blockId) {
        var restored = findVariantByBlock(editorState.blockId);
        if (restored) showInEditor(restored, editorState.stepOverride);
      }
      return;
    }

    if (window.location.pathname === '/challenge') return;

    if (forcedKey) {
      var forced = variants.filter(function (v) { return v.testMode; })[0];
      if (forced) forced.start();
      return;
    }

    rememberFooterSignup();

    var candidates = variants.filter(function (v) { return v.cfg.active; });
    (function next(i) {
      if (i >= candidates.length) return;
      matches(candidates[i].cfg).then(function (ok) {
        if (ok) candidates[i].start();
        else next(i + 1);
      }, function () { next(i + 1); });
    })(0);
  }

  function findVariantByBlock(blockId) {
    var found = null;
    document.querySelectorAll('[data-vkp-root]').forEach(function (root) {
      (root.vkpVariants || []).forEach(function (v) {
        if (v.cfg.blockId === blockId) found = v;
      });
    });
    return found;
  }

  function initAll() {
    document.querySelectorAll('[data-vkp-root]').forEach(initRoot);
  }

  window.VkPopup = { openVariant: null, init: initAll, rules: RULES };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-vkp-root]');
    if (root) initRoot(root);
  });
  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target.querySelector('[data-vkp-root]');
    if (!root || !root.vkpVariants || !root.vkpVariants.length) return;
    var target = findVariantByBlock(editorState.blockId) || root.vkpVariants[0];
    if (target) {
      editorState.blockId = target.cfg.blockId;
      showInEditor(target, editorState.stepOverride);
    }
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    var root = event.target.querySelector('[data-vkp-root]');
    if (!root) return;
    var bar = root.querySelector('[data-vkp-editor-bar]');
    if (bar) bar.hidden = true;
    (root.vkpVariants || []).forEach(function (v) {
      v.close(true);
      v.setTeaser(false);
      v.el.hidden = true;
    });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var blockId = event.detail && event.detail.blockId;
    var variant = findVariantByBlock(blockId);
    if (variant) {
      if (editorState.blockId !== blockId) editorState.stepOverride = null;
      editorState.blockId = blockId;
      showInEditor(variant, editorState.stepOverride);
    }
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var variant = findVariantByBlock(event.detail && event.detail.blockId);
    if (variant) {
      variant.close(true);
      variant.setTeaser(false);
      variant.el.hidden = true;
    }
  });
})();
